import * as React from 'react';

const SvgShareFill = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M3 20C3 16.946 5.963 8 14.004 8.07L14.02 4h1.44L22 10.494 15.435 17h-1.438v-4C5.963 13 3.008 19.984 3 20Z", fill: "currentColor" })));

export { SvgShareFill as default };
